<div class="container-md w-full sm:w-3/5 md:w-4/5 xl:w-3/5 alert alert-warning alert-button" role="alert">
  <div>
    <i-feather name="alert-triangle" class="text-warning mr-2 flex-shrink-0"></i-feather>
  </div>
  <div innerHtml="{{ message }}"></div>
</div>
